export enum PAY_CHANNEL {
  WECHAT = 'wechat',
  ALIPAY = 'alipay',
}

export enum SKU_TYPE {
  VIP = 'member',
  PURCHASE = 'purchase',
}

export enum ORG_TYPE {
  PERSONAL = 'personal',
  TEAM = 'team',
}
